import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field"]

  toggle(event) {
    this.fieldTarget.classList.toggle("d-none", event.target.value !== "0")
  }
}
